import angular from 'angular';

angular.module('cloudX').directive('cxAddressSelect', [
  function() {
    return {
      restrict: 'E',
      template: require('./addressSelect.html'),
      scope: {
        addressReference: '=data',
        relation: '=',
        save: '&',
        setIfOne: '@',
        medium: '=',
        disabled: '=?',
      },
      require: ['^cxRelationFile', 'cxAddressSelect'],
      link: function(scope, element, attrs, ctrls) {
        if (!ctrls || ctrls.length !== 2) return;

        var relFile = ctrls[0];
        var addrSelect = ctrls[1];

        scope.gotoAddresses = function() {
          return relFile.gotoField(scope.relation.addressesFieldId);
        };
      },
      controller: [
        '$scope',
        'relBindSvc',
        'commOutSvc',
        'resourceFactorySvc',
        '$filter',
        'openNewAddressSvc',
        function($scope, relBindSvc, commOutSvc, resourceFactorySvc, $filter, openNewAddressSvc) {
          // we add the option of setting the attribute setIfOne to true for when used in form (eg new commSetting) that will be saved.
          // in that case, when only one option is available, that one is set by default.
          $scope.setIfOne = $scope.setIfOne === 'true';
          //var relation = relBindSvc.relations[$scope.relId];
          $scope.empty = { id: '', medium: $scope.medium[0] };
          $scope.noAddresses = false;
          var loadingAddressesPromise = null;
          $scope.getAddresses = function() {
            if (!$scope.relation[$scope.relation.addressesFieldId]) {
              if (loadingAddressesPromise) return loadingAddressesPromise;
              loadingAddressesPromise = resourceFactorySvc
                .get('address')
                .query(
                  {
                    id: $scope.relation.id,
                  },
                  function(data) {
                    $scope.relation[$scope.relation.addressesFieldId] = {
                      value: data,
                      type: 12,
                    };
                    return $scope.getAddresses();
                  },
                )
                .$promise.finally(function() {
                  loadingAddressesPromise = null;
                });
              return loadingAddressesPromise;
            }
            var addresses = $scope.relation[$scope.relation.addressesFieldId].value.filter(function(
              a,
            ) {
              return $scope.medium.includes(a.medium);
            });
            $scope.noAddresses = false;
            $scope.empty.addressData = '';
            if (
              !$scope.addressReference ||
              $scope.addressReference === '00000000-0000-0000-0000-000000000000'
            ) {
              if (addresses.length === 1 && $scope.setIfOne) {
                $scope.wrapAndSave(addresses[0].id);
                $scope.addressReference = addresses[0].id;
                return addresses;
              } else if (addresses.length === 0) {
                $scope.empty.addressData = $filter('translate')('No addresses entered yet');
                $scope.noAddresses = true;
              } else {
                $scope.empty.addressData = $filter('translate')('Select an address');
              }
              //addresses.unshift($scope.empty);
            }
            return addresses;
          };
          $scope.getAddresses();
          $scope.wrapAndSave = function($data) {
            if ($data === '00000000-0000-0000-0000-000000000000' || !$data) return false;
            return $scope.save({
              newValue: {
                ReferenceFieldId: $scope.relation.addressesFieldId,
                ValueId: $data,
              },
            });
          };

          $scope.newAddress = function() {
            if ($scope.gotoAddresses) {
              $scope.gotoAddresses().then(function() {
                openNewAddressSvc.openNewAddress($scope.medium[0]);
              });
            }
          };
          openNewAddressSvc.registerCallback($scope, $scope.getAddresses);
        },
      ],
    };
  },
]);
